import React from 'react';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import gettext from '../../utils/django/gettext';

const sharedProps = {
    href: 'https://help.gaiagps.com/',
    rel: 'noopener noreferrer',
    target: '_blank',
    children: gettext('Help'),
};

function isHidden(user: User | undefined) {
    return !user || !user.hasSubscription;
}

function Toolbar(
    props: React.HTMLProps<HTMLAnchorElement> & {user: User | undefined}
) {
    if (isHidden(props.user)) return null;
    return <a {...props} {...sharedProps} />;
}

const HamburgerMenu = React.forwardRef(
    // eslint-disable-next-line prefer-arrow-callback
    function HamburgerMenuInner(
        props: MenuItemAnchorProps & {user: User | undefined},
        ref: React.Ref<any>
    ) {
        if (isHidden(props.user)) return null;
        return <MenuItemAnchor ref={ref as any} {...props} {...sharedProps} />;
    }
);

export default {Toolbar, HamburgerMenu};
